module.exports = __webpack_public_path__ + "static/media/peachprincess.f4d2968f.png";